import onetime from "@-/com.npmjs.onetime";
import type { CapturedAnalyticsEvent } from "#analytics-event";

export type AnalyticsEventListener = (event: CapturedAnalyticsEvent) => void;

const getListeners = onetime((): Set<AnalyticsEventListener> => new Set());

export function notifyAnalyticsEventListeners(event: CapturedAnalyticsEvent): void {
  const listeners = getListeners();
  for (const listener of listeners) {
    try {
      listener(event);
    } catch {
      // A subscriber must never break the capture that notified it.
    }
  }
}

/** Observes every captured event after the analytics context is merged. */
export function subscribeToAnalyticsEvents(listener: AnalyticsEventListener): () => void {
  const listeners = getListeners();
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/**
 * Records captured events until `stop()`. Tests assert instrumentation through this real
 * subscriber instead of mocking the PostHog client (which tests disable).
 */
export function recordAnalyticsEvents(): {
  events: CapturedAnalyticsEvent[];
  stop: () => void;
} {
  const events: CapturedAnalyticsEvent[] = [];
  const stop = subscribeToAnalyticsEvents((event) => events.push(event));
  return { events, stop };
}
